import type { AssetClass } from '@/types'
import { UNDERWRITING_ASSET_CLASSES } from '@/types/underwritingModels'

/** Letters and digits only, lower case: "Self Storage" and "Self-Storage" agree. */
function key(text: string): string {
  return text.toLowerCase().replace(/[^a-z0-9]/g, '')
}

/** The platform's asset types (backend `dealfields.ASSET_TYPE_OPTIONS`) that
 *  the model library files under another name. */
const PLATFORM_ALIASES: Record<string, AssetClass> = {
  seniorhousing: 'Senior Living',
  medicaloffice: 'Office',
}

/**
 * The underwriting model a deal's own asset class selects, or null when the
 * deal names none the model library has. The page used to keep the last tab a
 * person picked (Multifamily by default), so an Industrial deal opened on the
 * Multifamily model (nd3-25) — and so did a "Self Storage" deal, the platform's
 * spelling of the library's Self-Storage model.
 */
export function assetClassForDeal(assetType: unknown): AssetClass | null {
  const text = key(String(assetType ?? ''))
  if (!text) return null
  return (
    UNDERWRITING_ASSET_CLASSES.find((ac) => key(ac) === text) ?? PLATFORM_ALIASES[text] ?? null
  )
}
